// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CameraOutlinedSvg from "@fishx/icons-svg/es/asn/CameraOutlined";
import FishxIcon from '../components/FishxIcon';

var CameraOutlined = function CameraOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CameraOutlinedSvg
  }));
};

CameraOutlined.displayName = 'CameraOutlined';
export default React.forwardRef(CameraOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CameraOutlined.js
// module id = 2158
// module chunks = 0